import { Link } from "react-router-dom";

const focusRing =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-brand-400 dark:focus-visible:ring-offset-gray-900";

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-gray-50 dark:border-gray-800 dark:bg-gray-900">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <Link
              to="/"
              className={`inline-flex cursor-pointer items-center gap-2 text-gray-900 transition-opacity hover:opacity-80 dark:text-gray-100 ${focusRing}`}
            >
              <span className="text-lg font-bold tracking-tight">다봄</span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-gray-600 break-keep dark:text-gray-400">
              국비 지원 IT 훈련을 앞두고, 결정하기 전에 숫자부터 보는 자리입니다.
            </p>
          </div>

          <nav aria-label="사이트 메뉴">
            <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              바로가기
            </p>
            <ul className="mt-2 space-y-1 text-sm">
              <li>
                <Link
                  to="/"
                  className={`inline-flex min-h-11 items-center text-gray-600 transition-colors hover:text-brand-700 dark:text-gray-400 dark:hover:text-brand-400 ${focusRing}`}
                >
                  홈
                </Link>
              </li>
              <li>
                <Link
                  to="/자가진단"
                  className={`inline-flex min-h-11 items-center text-gray-600 transition-colors hover:text-brand-700 dark:text-gray-400 dark:hover:text-brand-400 ${focusRing}`}
                >
                  자가진단
                </Link>
              </li>
              <li>
                <Link
                  to="/과정비교"
                  className={`inline-flex min-h-11 items-center text-gray-600 transition-colors hover:text-brand-700 dark:text-gray-400 dark:hover:text-brand-400 ${focusRing}`}
                >
                  과정비교
                </Link>
              </li>
              <li>
                <a
                  href="https://aileap.co.kr/실부담/"
                  rel="nofollow"
                  className={`inline-flex min-h-11 items-center text-gray-600 transition-colors hover:text-brand-700 dark:text-gray-400 dark:hover:text-brand-400 ${focusRing}`}
                >
                  실부담 계산
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              문의
            </p>
            <p className="mt-3 text-sm leading-relaxed text-gray-600 break-keep dark:text-gray-400">
              고용노동상담센터 1350
              <br />
              총괄운영기관(한국직업능력연구원) 044-415-3869
            </p>
          </div>
        </div>

        <div className="mt-10 space-y-3 border-t border-gray-200 pt-6 text-sm leading-relaxed text-gray-600 dark:border-gray-800 dark:text-gray-400">
          <p className="break-keep">
            카드(KDT 등 특화훈련) 판정 문안은 「국민내일배움카드 운영규정」(고용노동부고시
            제2026-39호, 시행 2026-05-11)과 `내일배움카드_이동판정.md`(2026-08-11 원문
            대조)를 옮긴 것입니다. K-뉴딜 판정 문안은 고용24 「고용정책 상세 — K-뉴딜
            아카데미」 제도안내(2026-07-22 최종수정)의 참여자격·참여제한 조항을 옮긴
            것입니다. 두 축 모두 사업 지침은 회차·운영기관에 따라 더 좁게 운용될 수 있고,
            최종 판정은 운영기관이 합니다.
          </p>
          <p className="break-keep">
            이 사이트의 제도 기준값은 <strong>2026-08-16</strong> 기준입니다. 최신 고시·공고는
            고용24 및 해당 운영기관에서 확인하세요.
          </p>
        </div>

        <div className="mt-6 flex flex-col gap-3 border-t border-gray-200 pt-6 text-xs text-gray-500 dark:border-gray-800 dark:text-gray-400 sm:flex-row sm:items-center sm:justify-between">
          <p className="break-keep">
            운영: 다봄 ·{" "}
            <a
              href="https://aileap.co.kr/"
              rel="nofollow"
              className={`inline-flex min-h-11 items-center transition-colors hover:text-gray-700 dark:hover:text-gray-300 ${focusRing}`}
            >
              aileap.co.kr
            </a>
          </p>
          <a
            href="https://aileap.co.kr/개인정보처리방침"
            rel="nofollow"
            className={`inline-flex min-h-11 items-center whitespace-nowrap transition-colors hover:text-gray-700 dark:hover:text-gray-300 ${focusRing}`}
          >
            개인정보처리방침
          </a>
        </div>
      </div>
    </footer>
  );
}